import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActivityChartsComponent } from './activity-charts/activity-charts.component';
import { UserErrorsComponent } from './user-errors/user-errors.component';
import { WebErrorsComponent } from './web-errors/web-errors.component';
import { HistoricChartsComponent } from './historic-charts/historic-charts.component';
import { ServiceBusMetricsComponent } from './service-bus-metrics/service-bus-metrics.component';
import { PullRequestReportsComponent } from './pull-request-reports/pull-request-reports.component';
import { BuildHealthComponent } from './build-health/build-health.component';
import { ErrorManagementComponent } from 'src/app/error-management/error-management.component';
import { OldFeatureFlagChartComponent } from 'src/app/old-feature-flag-chart/old-feature-flag-chart.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotFoundComponent } from 'src/app/not-found/not-found.component';
import { AdalRoleGuard } from 'src/app/adal.role.guard';
import { AgentCapabilitiesComponent } from './agent-capabilities/agent-capabilities.component';

const routes: Routes = [
  // default
  { 
    path: '', redirectTo: 'dashboard', pathMatch: 'full'
  },
  { 
    path: 'dashboard', component: DashboardComponent, canActivate: [AdalRoleGuard], 
    data: {
      title: 'Dashboard',
      roles: ['Observer', 'Writer', 'Admin'],
      icon: 'dashboard',
      autoReload: {min: 5, max: 10}
    }
  },
  { 
    path: 'buildHealth', component: BuildHealthComponent, canActivate: [AdalRoleGuard], 
    data: {
      title: 'Build Health',
      roles: ['Observer', 'Writer', 'Admin'],
      icon: 'build',
      autoReload: {min: 5, max: 10}
    } 
  },
  { 
    path: 'serviceBusMetrics', component: ServiceBusMetricsComponent, canActivate: [AdalRoleGuard], 
    data: {
      title: 'Service Bus Metrics',
      roles: ['Observer', 'Writer', 'Admin'],
      icon: 'notifications'
    }
  },
  { 
    path: 'oldFeatureFlagChart', component: OldFeatureFlagChartComponent, canActivate: [AdalRoleGuard], 
    data: {
      title: 'Old Feature Flags',
      roles: ['Admin'],
      icon: 'flag'
    }
  },
  {
    path: 'agentCapabilities', component: AgentCapabilitiesComponent, canActivate: [AdalRoleGuard],
    data: {
      title: 'Agent Capabilities',
      roles: ['Admin'],
      icon: 'whatshot'
    }
  },

  // not found
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
